import { observer } from "mobx-react";
import React, { FC, useMemo } from "react";
import { Box, Flex, VStack } from "@chakra-ui/react";
import { AccountAnalyticsStore } from "store/UserAccounts/UserAccount/AccountAnalytics/AccountAnalytics.store";
import { Loader } from "components";
import { LeadAttributionPeopleList } from "./LeadAttributionPeopleList";
import { transformLeadAttributionStatItem } from "utils/account-lead-attribution-analytics.utils";
import { LeadBlockHeader } from "../../../../leads/components/LeadDrawer/LeadBlocks/LeadBlockHeader";
import { LeadAttributionPeopleGroupSubFilters } from "./LeadAttributionPeopleGroupSubFilters";

interface IProps {
  accountAnalyticsStore: AccountAnalyticsStore;
}

export const LeadAttributionPeople: FC<IProps> = observer(
  ({ accountAnalyticsStore }) => {
    const {
      accountAnalyticsLeadAttributionStore: {
        accountLeadAttributionPeopleStore,
      },
    } = accountAnalyticsStore;

    const {
      selectedStatItemByType,
      isFetchingInProgress,
    } = accountLeadAttributionPeopleStore;

    const transformedLeadAttributionStat = useMemo(() => {
      return transformLeadAttributionStatItem(selectedStatItemByType);
    }, [selectedStatItemByType]);

    const selectedGroup = useMemo(() => {
      return transformedLeadAttributionStat?.group || null;
    }, [transformedLeadAttributionStat]);

    return (
      <Flex
        flexDirection={"column"}
        height={"100%"}
        width={"100%"}
        bg={"leadpro.900"}
        p={6}
      >
        <VStack align={"left"} width={"100%"} spacing={4}>
          <Box fontSize={"lg"} fontWeight={600} mb={4} color={"leadpro.500"}>
            {selectedGroup}
          </Box>
          <Box fontSize={"sm"} color={"leadpro.500"}>
            Below are the people who's leads make up this attribution metric.
            Multiple leads can be associated with an individual person, click
            the view leads action to open that person’s leads in a new tab.
          </Box>
          <LeadAttributionPeopleGroupSubFilters
            accountAnalyticsStore={accountAnalyticsStore}
            group={selectedGroup}
          />
        </VStack>
        <LeadBlockHeader pl={0}>People</LeadBlockHeader>
        <Box
          width={"100%"}
          flex={1}
          minH={0}
          marginTop={4}
          position={"relative"}
        >
          <LeadAttributionPeopleList
            accountAnalyticsStore={accountAnalyticsStore}
          />
        </Box>
        <Box
          minHeight={"40px"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          position={"relative"}
          width={"100%"}
        >
          {isFetchingInProgress && <Loader size={"lg"} />}
        </Box>
      </Flex>
    );
  }
);
